// extracted by mini-css-extract-plugin
export default {"main":"maismenos_main__NcpFn","box":"maismenos_box__MCVs-","name":"maismenos_name__3pOPM"};